import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {SortTable} from './sort-table.component';
import {Sort} from '@angular/material';
import {AppComponent} from './app.component';
import {StocksService} from './stocks.service';
import {FileDownloadService} from './file-download.service';

import {ArticleReleaseService} from './article-release.service';

import {Router} from '@angular/router';
import {DatePipe} from '@angular/common';

@Component({
    selector: 'enter-stock',
    templateUrl: './templates/article-release.component.html',
    styleUrls: ['./styles/article-release-spec.component.css', './styles/article-release.component.css'],
    providers: [TransactionsService, AuthentificationService, SortTable, StocksService, FileDownloadService, ArticleReleaseService],
    encapsulation: ViewEncapsulation.None
})

export class ArticleReleaseComponent implements OnInit {

    session_mode: string = "RECEPTION";
    id_purchase_order: number = 0;
    bcf_details: any;
    bcf_name: string;
    bcf_receipt_list: any;
    validate_bt: boolean = true;
    disabled_input: boolean = true;
    bfc_validate: any = [];
    complete_infos: boolean = false;
    articles_list_popup: Array<any> = [];
    article_selected_list: Array<string> = [];
    motif: string = "";
    selectedValue: string = "BRET";
    global_remark: string = "";
    remains_to_deliver: Array<any> = [];
    docket_date: any = new Date();
    number_reference: any = "";
    enter_name: string = "";

    actions = [
        {value: 'BRET', viewValue: 'Annuler sortie'},
        {value: 'BLC_BRLC', viewValue: 'Livrer et reste en attente'},
        {value: 'BLC_M', viewValue: 'Livrer et annuler reste'}
    ];

    constructor(
        private app_component: AppComponent,
        private filedownloadservice: FileDownloadService,
        private transactions_service: TransactionsService,
        private router: Router,
        private authentification_service: AuthentificationService,
        private sort_table: SortTable,
        private stock_service: StocksService,
        private article_release_service: ArticleReleaseService,
        private datepipe: DatePipe
    ) {
        this.CheckUSerSession();
        this.app_component.valTest = '/article-release';
        this.app_component.GetParent();
    }

    Exists(id_article: string, selected: Array<string>): boolean {
        return selected.indexOf(id_article) > -1;
    }

    Toggle(pannier: any, selected: Array<string>): void {

        var index = selected.indexOf(pannier.id_article);
        if (index > -1) {
            selected.splice(index, 1);
        }
        else {
            selected.push(pannier.id_article);
        }
        this.EditArticleSessionPurchaseDetail(pannier);
    };

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    GetSentReleaseOrder() {
        this.transactions_service.GetSentReleaseOrder().then(result => {this.bcf_receipt_list = result['list']; this.bfc_validate = result['list']; this.sort_table.SetDataArray(result['list'], [{value: "name", type: ""}, {value: "supplier", type: ""}, {value: "date", type: ""}, {value: "user", type: ""}]);});
    }

    SortValidate(sort: Sort): void {
        this.sort_table.sortData(sort);
        this.bfc_validate = this.sort_table.GetSortData();
    }

    OrderDetails(bcf: any): void {
        this.notconforme = false;
        this.id_purchase_order = bcf.id_purchase_order;
        this.bcf_name = bcf.name;

        this.transactions_service.GetOsDetails(bcf.id_purchase_order).then(result => {
            this.bcf_details = result['list'];
            //            for (var i = 0; i < this.bcf_details.length; i++) {
            //                this.bcf_details[i]['id_article_location'] = this.bcf_details[i]['locations'][0]['id_article_location'];
            //            }
            this.motif = result['motif'];
            this.number_reference = parseInt(result['last_number_reference']) + 1;
            this.enter_name = result['name'];
            this.docket_date = new Date();
            if (result['list'].length !== 0) {
                this.validate_bt = false;
                this.UpdateCheckedList();
            }
        });
    }

    UpdateCheckedList(): void {
        this.article_selected_list = [];
        for (let i = 0; i < this.bcf_details.length; i++) {
            if (this.bcf_details[i]['conforme'] === "yes") {
                this.article_selected_list.push(this.bcf_details[i]['id_article']);
            }
        }
    }

    AddArticleInfos(): void {
        if (!this.notconforme) {
            this.selectedValue = "";
        }
        this.transactions_service.AddArticleInfosOs(this.global_remark, this.id_purchase_order, this.selectedValue).then(result => {
            this.SessionModPopup(result['issued']);
            this.TotalArticle(result['issued'], result['remains_to_deliver']);
            this.articles_list_popup = result['issued'];
            this.remains_to_deliver = result['remains_to_deliver'];
            this.bfc_validate = result['list'];
            this.notconforme = false;
            this.validate_bt = true;
            if (result['issued'].length > 0 || result['remains_to_deliver'].length > 0) {
                this.complete_infos = true;
                this.app_component.hide_wrapper(true);
            }
            if (result['issued'].length === 0 && result['remains_to_deliver'].length === 0) {
                this.bcf_details = [];
            }
        });
    }

    total_art_top: number = 0;
    total_art_bottom: number = 0;
    TotalArticle(list1: any, list2: any): void {
        this.total_art_top = 0;
        this.total_art_bottom = 0;
        for (let i = 0; i < list1.length; i++) {
            this.total_art_top = this.total_art_top + parseInt(list1[i]['qte_received']);
        }
        for (let i = 0; i < list2.length; i++) {
            this.total_art_top = this.total_art_top + parseInt(list2[i]['qte_received']);
        }
    }

    EditArticleSessionPurchaseDetail(pannier: any): void {
        let checked = this.article_selected_list.join('_');
        this.transactions_service.EditArticleSessionOSDetailBcf(pannier.id_article, checked).then(result => {
            this.bcf_details = result['list'];
            this.disabled_input = false;
            this.SessionMod(result['list']);
            this.IsConforme(result['list']);
            this.UpdateCheckedList();
        });
    }

    notconforme: boolean = false;
    IsConforme(list: any): void {
        this.notconforme = false;
        this.selectedValue = "";
        for (let i = 0; i < list.length; i++) {
            if (list[i]['conforme'] === "no") {
                this.notconforme = true;
                this.selectedValue = "BRET";
                break;
            }
        }
    }

    LoadSessionPurchase() {
        this.transactions_service.GetSentPurchaseOrderDetails()
            .then(session_list => {
                this.bcf_details = session_list['list'];
                if (session_list['list'].length !== 0) {
                    this.validate_bt = false;
                }
            });
    }

    EditAndValidateModification(prod: any): void {
        console.log(prod.status);
        if (prod.status === "RECEPTION") {
            this.EditArticleSessionPurchaseDetail(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPurchaseDetail(prod);
        }
    }

    SessionMod(list: any): void {
        this.session_mode = "RECEPTION";
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === "MODIFICATION") {
                this.session_mode = "MODIFICATION";
            }
        }
    }

    session_mode_pop_up: string = "KO";
    SessionModPopup(list: any): void {
        this.session_mode_pop_up = "OK";
        for (let i = 0; i < list.length; i++) {
            if (list[i].serial_status === "KO") {
                this.session_mode_pop_up = "KO";
            }
        }
    }

    ValidateEditArticleSessionPurchaseDetail(prod: any): void {
        if (isNaN(prod.qte_received)) {
            prod.qte_received = "Valeur invalide";
            setTimeout(() => {this.LoadSessionPurchase()}, 3500);
        }
        else {
            this.transactions_service.ValidateEditArticleSessionOSDetail(prod).then(result => {
                if (result['result_emplacement'] != '0') {
                    this.bcf_details = result['list'];
                    this.SessionMod(result['list']);
                    this.IsConforme(result['list']);
                    this.UpdateCheckedList();
                } else {
                    //                    this.nbr_to_place = prod.quantity;
                    this.GetNbrResteToPlace();
                    this.SelectLocation(prod);
                }
            });
        }
    }

    Cancel(): void {
        this.complete_infos = false;
        this.app_component.hide_wrapper(false);
    }

    IsAvalableSerialNumber(article: any): void {
        this.stock_service.IsAvalableSerialNumber(article).then(result => {this.articles_list_popup = result['list']; console.log(result['result']);});
    }

    ValidateForm(): void {
        var indices = [];
        var index = this.articles_list_popup.findIndex(article => article['serial'] === "Entrez le n° de série");
    }


    ValidatePop(): void {
        this.ValidatePannierPurchaseDetail();
    }

    ValidatePannierPurchaseDetail(): void {
        this.transactions_service.ValidatePannierOutOfWareDetails(this.id_purchase_order, this.bcf_name, this.datepipe.transform(this.docket_date, 'medium')).then(result => {
            this.bfc_validate = result['list'];
            this.bcf_details = [];
            this.bcf_receipt_list = result['sent'];
            this.validate_bt = true;
            this.bcf_name = "";
            this.notconforme = false;
            this.sort_table.SetDataArray(result['sent'], [{value: "name", type: ""}, {value: "supplier", type: ""}, {value: "date", type: ""}, {value: "user", type: ""}]);
            this.complete_infos = false; this.app_component.hide_wrapper(false);
        });
    }

    EditAndValidateModificationPopup(prod: any): void {
        if (prod.status === "RECEPTION") {
            this.EditArticleSessionPopup(prod);
        } else if (prod.status === 'MODIFICATION') {
            this.ValidateEditArticleSessionPopup(prod);
        }
    }

    EditArticleSessionPopup(prod: any): void {
        this.stock_service.EditArticleSessionReceiptOs(prod.index).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

    ValidateEditArticleSessionPopup(prod: any): void {
        this.stock_service.ValidateEditArticleSessionIssuePopup(prod).then(result => {this.articles_list_popup = result['list']; this.SessionModPopup(result['list'])});
    }

    CancelArticleInfos() {
        this.stock_service.CancelEnterStock().then(result => {
            this.validate_bt = true;
            this.bcf_details = result['list'];
            this.motif = result['motif'];
            this.number_reference = undefined;
            this.docket_date = undefined;
            this.enter_name = "";
            this.notconforme = false;
        });
    }

    DownloadPdf(): void {
        this.filedownloadservice.IssueDocket(this.number_reference, this.datepipe.transform(this.docket_date, 'dd-MM-yyyy'), this.enter_name);
    }

    selected_tr: number = -1;
    Selected(value: number): void {
        this.selected_tr = value;
    }

    Color(index: number) {
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {
                'background-color': '#B3B6B7', //'#FFB400',
            };
        }
        return styles;
    }


    ColorIndex(index: number) {
        let styles = {
        };
        if (this.selected_tr === index) {
            styles = {
                'color': 'white',
            };
        }
        return styles;
    }

    ngOnInit() {
        this.GetSentReleaseOrder();
    }

    set_emplacement: boolean = false;
    article_locations_list: Array<any> = [];
    id_article: any = 0;
    quantity: any = 0;
    id_article_location: any = 0;

    SelectLocation(article: any) {
        this.id_article = article.id_article;
        this.quantity = article.qte_received;
        this.set_emplacement = true;
        this.app_component.hide_wrapper(this.set_emplacement);
        this.GetLocationsNotEmpty(article);
    }

    GetLocationsNotEmpty(article: any) {
        this.article_release_service.GetLocationsNotEmpty(this.id_article, article.qte_received)
            .then(result => {
                this.article_locations_list = result['list'];
                this.id_article_location = this.article_locations_list[0]['id_article_location'];
            });
    }

    CancelEmplacement(): void {
        this.set_emplacement = false;
        this.app_component.hide_wrapper(this.set_emplacement);
    }

    nbr_to_place: any = 0;
    LimitResteToPlace(docket: any, saisi: any) {
        saisi = Number(saisi);
        var total_placed = 0;
        var tmp_saisi = 0;
        for (var i = 0; i < this.article_locations_list.length; i++) {
            if (this.article_locations_list[i].id_location != docket.id_location) {
                total_placed = total_placed + Number(this.article_locations_list[i].to_release);
            }
        }
        var nbr_to_place_without = Number(this.quantity) - total_placed;
        for (var i = 0; i < saisi && i < (docket.current_quantity) && i < nbr_to_place_without; i++) {
            tmp_saisi++;
        }
        saisi = tmp_saisi;
        docket.to_release = saisi;
        this.GetNbrResteToPlace();
    }

    GetNbrResteToPlace() {
        var tmp = 0;
        for (var i = 0; i < this.article_locations_list.length; i++) {
            tmp = tmp + Number(this.article_locations_list[i].to_release);
        }
        this.nbr_to_place = Number(this.quantity) - tmp;
        tmp = 77;
    }

    SetLocationsForThisLine() {
        var emplacements = '';
        for (var i = 0; i < this.article_locations_list.length; i++) {
            if (Number(this.article_locations_list[i]['to_release']) != 0) {
                emplacements = emplacements + '' + this.article_locations_list[i]['id_article_location'] + ':' + this.article_locations_list[i]['to_release'] + '_';
            }
        }
        this.article_release_service.SetLocationRealeaseSession(this.id_article, emplacements)
            .then(response => {
                this.bcf_details = response['list'];
                this.SessionMod(response['list']);
                this.CancelEmplacement();
            });
    }

    NextStep() {
        //        this.complete_infos = false;
        //        this.app_component.hide_wrapper(this.complete_infos);
        //
        //        this.set_emplacement = true;
        //        this.app_component.hide_wrapper(this.set_emplacement);
        //        this.AddLocationsToOsOrderDetailsSession();
        this.ValidatePop();
    }

    Preview() {
        this.complete_infos = true;
        this.set_emplacement = false;
        this.app_component.hide_wrapper(this.set_emplacement);
        this.app_component.hide_wrapper(this.complete_infos);
    }

    location_temp: any = {
        current_quantity: "",
        id_article: "",
        id_article_location: "",
        id_location: "",
        reference: "",
        to_release: ''
    };

    AddLocationsToOsOrderDetailsSession() {
        this.article_release_service.AddLocationsToOsOrderDetailsSession()
            .then(result => {
                this.article_locations_list = result['list'];
                console.log(this.article_locations_list);
            });
    }

    recap_to_send: any = {
        index_sess: '',
        quantity: '',
        quantity_to_release: '',
        location: ''
    }

    GetQuantityForThisLocation(event: any, index: any) {
        var idx = this.article_locations_list.findIndex(location => location.index === index);
        var locations = this.article_locations_list[idx]['locations'];

        var id_article_location = this.article_locations_list[idx]['location_temp']['id_article_location'];
        var idx_a = locations.findIndex(loc => loc.id_article_location === id_article_location);

        //        miditra server : calculer to_release pour l'emplacement'

        this.article_locations_list[idx]['location_temp']['to_release'] = this.article_locations_list[idx]['locations'][idx_a]['to_release'];
        this.AddNewLine(event, index);
    }

    AddNewLine(event: any, idx_loct: any) {
        var index = this.article_locations_list.findIndex(location => location.index === idx_loct);
        this.recap_to_send.index_sess = idx_loct;
        this.recap_to_send.quantity = this.article_locations_list[index]['qte_received'];
        this.recap_to_send.quantity_to_release = this.article_locations_list[index]['location_temp']['to_release'];
        this.recap_to_send.location = this.article_locations_list[index]['location_temp']['id_article_location'];
        this.AddNewLineSession(this.recap_to_send);
        //        console.log(idx_loct);
        //        console.log(this.article_locations_list);
        //        console.log(this.location_temp);
        //
        //        let temp = this.article_locations_list[index];
        //        temp['index'] = 0;
        //        temp['location_temp'] = (this.location_temp);
        //        console.log(temp);
        //        this.article_locations_list.push(temp);
        //        console.log("between");
        //        console.log(this.article_locations_list);
        //        this.article_locations_list = this.article_locations_list.sort((obj1, obj2) => {
        //            if (obj1.id_article > obj2.id_article) {
        //                return 1;
        //            }
        //            if (obj1.id_article < obj2.id_article) {
        //                return -1;
        //            }
        //            return 0;
        //        });
        //        console.log("after");
        //        console.log(this.article_locations_list);
    }

    AddNewLineSession(recap_to_send: any) {
        this.article_release_service.AddNewLineSession(recap_to_send).then(result => {
            this.article_locations_list = result['list'];
            console.log(this.article_locations_list);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/article-release.component.ts